module.exports = __webpack_public_path__ + "static/media/Ikenna Ifekaonwu - Pdf.0316def2.pdf";